<template>
    <div>
        <template v-if="crud_vendor !== null && wizard_cycle !== null && crud_vendor === true">
            <div v-show="showData === true">
                <div class="modal fade" id="editVendor" tabindex="-1" role="dialog" aria-labelledby="vendorEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editVendorContractData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Contact Detail</h2>
                                        <button :disabled="contract_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()">Cancel</a>
                                    </div>
                                    <div class="form-group">
                                        <label for class="label block-label">Contract Type</label>
                                        <label class="radio-holder ml-0 mb-0">
                                            Individual
                                            <input type="radio" v-model="contract_form.contract_type" value="INDIVIDUAL" id="btn-simsim" class="payment-transfer" name="vendorType" :checked="contract_form.contract_type=='INDIVIDUAL'">
                                            <span class="checkmark"></span>
                                        </label>
                                        <label class="radio-holder mb-0">
                                            Business
                                            <input v-model="contract_form.contract_type" type="radio" value="BUSINESS" id="btn-bank" class="payment-transfer" name="vendorType" :checked="contract_form.contract_type=='BUSINESS'">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="form-group">
                                        <label for class="label block-label">Onboarding Date</label>
                                        <datepicker name="starting_date" value="joinig_date" :bootstrap-styling="true" v-model="contract_form.starting_date" :class="{ 'is-invalid': contract_form.errors.has('starting_date') }"></datepicker>
                                        <has-error :form="contract_form" field="starting_date"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for class="label block-label">Vendor Categories</label>
                                        <select v-model="contract_form.category_id" class="custom-select2 selectpicker form-control" v-if="vendorCategories != null" :class="{ 'is-invalid': contract_form.errors.has('category_id') }">
                                            <option v-for="category in vendorCategories" v-bind:key="category.id" v-bind:value="category.id">{{category.name}}</option>
                                        </select>
                                        <has-error :form="contract_form" field="category_id"></has-error>
                                    </div>

                                    <div class="form-group">
                                        <label for class="label block-label">Company POC</label>
                                        <select v-model="contract_form.report_to" class="custom-select2 selectpicker form-control" v-if="users != null" :class="{ 'is-invalid': contract_form.errors.has('report_to') }">
                                            <option v-for="user in users" v-bind:key="user.id" v-bind:value="user.id">{{ user.name }}</option>
                                        </select>
                                        <has-error :form="contract_form" field="report_to"></has-error>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="editAddressVendor" tabindex="-1" role="dialog" aria-labelledby="vendorEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editVendorAddressData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Work Address Detail</h2>
                                        <button :disabled="address_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()">Cancel</a>
                                    </div>
                                    <div class="form-group">
                                        <label for class="label block-label">Current Address</label>
                                        <input autocomplete="off" type="text" class="form-control" name="address" v-model="address_form.current_address" :class="{ 'is-invalid': address_form.errors.has('current_address') }"/>
                                        <has-error :form="address_form" field="current_address"></has-error>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="editPaymentVendor" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-5 text-left">
                                <div class="popup-head mb-4 line-head">
                                    <h2 class="pb-3"> Payment Detail </h2>
                                </div>
                                <easyPaisaBeneficiaryComponent v-if="$global.user_company_payment_engine == 'EASY_PAISA'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <fincaBeneficiaryComponent v-if="$global.user_company_payment_engine == 'FINCA'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <meezanBeneficiaryComponent v-if="$global.user_company_payment_engine == 'MEEZAN'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <nbpFundsBeneficiaryComponent v-if="$global.user_company_payment_engine == 'NBP_FUND'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <faysalBeneficiaryComponent v-if="$global.user_company_payment_engine == 'FAYSAL'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <emoneyBeneficiaryComponent v-if="$global.user_company_payment_engine == 'EMONEY'" :form="payment_form" :banks="banks" :getEmployeeWalletDetail="getVendorWalletDetail" :addEmployeePaymentDetail="addVendorPaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                                <div class="people-management-inner-content">
                                    <div class="btn-holder text-right">
                                        <button class="btn btn-primary" @click="hidePopup()"> Cancel </button>
                                        <button class="btn btn-primary" @click="addVendorPaymentDetail()" disable="disable"> Save </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="editPersonalVendor" tabindex="-1" role="dialog" aria-labelledby="vendorEditLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body p-4">
                                <form @submit.prevent="editVendorPersonalData">
                                    <div class="clearfix popup-head mb-4">
                                        <h2 class="mt-2 float-left">Edit Personal Detail</h2>
                                        <button :disabled="personal_form.busy" class="btn btn-primary float-right submit_form">
                                            Save & Update
                                        </button>
                                        <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close" @click="reset()" >Cancel</a>
                                    </div>

                                    <div class="form-group">
                                        <label for class="label block-label">Company Name</label>
                                        <input autocomplete="off" type="text" class="form-control" name="companyName" v-model="personal_form.companyName" :class="{ 'is-invalid': personal_form.errors.has('companyName') }"/>
                                        <has-error :form="personal_form" field="companyName"></has-error>
                                    </div>

                                    <div class="form-group">
                                        <label for class="label block-label">Vendor Name</label>
                                        <input autocomplete="off" type="text" class="form-control" name="address" v-model="personal_form.full_name" :class="{ 'is-invalid': personal_form.errors.has('full_name') }"/>
                                        <has-error :form="personal_form" field="full_name"></has-error>
                                    </div>

                                    <div class="form-group">
                                        <label for class="label block-label">Mobile Number</label>
                                        <input autocomplete="off" type="text" @keypress="isNumber($event)" maxlength="12" class="form-control" name="address" v-model="personal_form.mobile_no" :class="{ 'is-invalid': personal_form.errors.has('mobile_no') }"/>
                                        <has-error :form="personal_form" field="mobile_no"></has-error>
                                    </div>

                                    <div class="form-group">
                                        <label for class="label block-label">Date Of Birth</label>
                                        <datepicker v-model="personal_form.dob" :class="{ 'is-invalid': personal_form.errors.has('dob') }" :bootstrap-styling="true"></datepicker>
                                        <has-error :form="personal_form" field="dob"></has-error>
                                    </div>

                                    <div class="form-group">
                                        <label for class="label block-label">CNIC</label>
                                        <input autocomplete="off" type="text" class="form-control" name="address" v-model="personal_form.cnic" :class="{ 'is-invalid': personal_form.errors.has('cnic') }"/>
                                        <has-error :form="personal_form" field="cnic"></has-error>
                                    </div>

                                    <div class="form-group">
                                        <label for class="label block-label">Email Address</label>
                                        <input autocomplete="off" type="text" class="form-control" name="address" v-model="personal_form.email" :class="{ 'is-invalid': personal_form.errors.has('email') }"/>
                                        <has-error :form="personal_form" field="email"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="label block-label"> Status </label>
                                        <select v-model="personal_form.status" name="status" class="form-control selectpicker custom-select2">
                                            <option value="ACTIVE">ACTIVE</option>
                                            <option value="INACTIVE">INACTIVE</option>
                                        </select>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="page-top mb-1 mb-3 clearfix">
                    <div class="pm-employee-info float-left">
                        <div class="info">
                            <strong class="title">{{ personal_form.full_name }}</strong>
                        </div>
                    </div>
                    <router-link class="sub-nav-link" to="/vendors">
                        <a href="#" class="btn btn-primary mt-2 float-right mr-1">Close</a>
                    </router-link>
                    <button v-if="deleteable" @click="deleteVendor(vendor_id)" class="btn btn-primary mt-2 float-right mr-1">Delete Vendor</button>
                </div>
                <div class="employee-view-tabs mb-4">
                    <ul class="nav nav-tabs nav-tabs-2" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="personal-tab" data-toggle="tab" href="#personal" role="tab" aria-controls="personal" aria-selected="false" >Personal Detail</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="job-detail-tab show active" data-toggle="tab" href="#job-detail" role="tab" aria-controls="job-detail" aria-selected="true" >Contact Detail</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="pay-detail-tab" data-toggle="tab" href="#pay-detail" role="tab" aria-controls="pay-detail" aria-selected="false" >Payment Method</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="pay-slip-tab" data-toggle="tab" href="#pay-slip" role="tab" aria-controls="pay-slip" aria-selected="false" >Payment Detail</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade" id="job-detail" role="tabpanel" aria-labelledby="job-detail-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left">Contact Detail</span>
                                        <a href="#" @click="showContractModal()" class="float-right" data-toggle="modal" data-target="#employeeEdit" v-if="crud_vendor == true">
                                            <i class="fas fa-pencil-alt"></i>
                                        </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Contract Type:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ contract_form.contract_type }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Category:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ category }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Onboarding Date:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ contract_form.starting_date }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Company POC:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ report_to_name }}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left">Work Address</span>
                                        <a href="#" @click="showAddressModal()" class="float-right" data-toggle="modal"
                                        data-target="#employeeEdit" v-if="crud_vendor == true">
                                            <i class="fas fa-pencil-alt"></i>
                                        </a>
                                    </label>
                                    <div class="pm-employee-detail-box">
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Address:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ address_form.current_address }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade show active" id="personal" role="tabpanel" aria-labelledby="personal-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left">Personal Detail</span>
                                        <a href="#" class="float-right" data-toggle="modal" data-target="#employeeEdit" @click="showPersonalModal()" v-if="crud_vendor == true">
                                            <i class="fas fa-pencil-alt"></i>
                                        </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Company Name:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ personal_form.companyName }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Vendor Name:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ personal_form.full_name }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Mobile Number:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ personal_form.mobile_no }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Date of Birth:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ personal_form.dob }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">CNIC:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ personal_form.cnic }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <strong class="title">Email:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ personal_form.email }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <strong class="title">Status:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ personal_form.status }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pay-detail" role="tabpanel" aria-labelledby="pay-detail-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left">Default Beneficiary</span>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Payment Method:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ payment_method }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Wallet Number:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ wallet }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left">Beneficiaries</span>
                                        <a href="#" class="float-right" data-toggle="modal"
                                        @click="loadBankList" v-if="crud_vendor == true">
                                            <i class="fas fa-pencil-alt"></i>
                                        </a>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row">
                                            <div class="col-sm-2">
                                                <strong>Acount Title</strong>
                                            </div>
                                            <div class="col-sm-2">
                                                <strong>Account Type</strong>
                                            </div>
                                            <div class="col-sm-3">
                                                <strong>Acount Number</strong>
                                            </div>
                                            <div class="col-sm-3">
                                                <strong>Bank name</strong>
                                            </div>
                                            <div class="col-sm-2">
                                                <strong>Beneficiary Status</strong>
                                            </div>
                                        </div>
                                        <div class="row" v-for="beneficiary in beneficiaries" v-bind:key="beneficiary.id" v-bind:value="beneficiary.id">
                                            <div class="col-sm-2">{{ beneficiary.account_title }}</div>
                                            <div class="col-sm-2">{{ beneficiary.account_type }}</div>
                                            <div class="col-sm-3">{{ beneficiary.account_number }}</div>
                                            <div class="col-sm-3">{{ beneficiary.bank_name }}</div>
                                            <div class="col-sm-2">
                                                <a href="javascript:void(0);" @click="makeDefault(beneficiary.id)" v-if="beneficiary.is_default == 'NO'">Mark Default</a>
                                                <a v-if="beneficiary.is_default == 'YES'">Default <i class="fa fa-check-circle" style="font-size:18px;color:green"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pay-slip" role="tabpanel" aria-labelledby="pay-slip-tab">
                        <div class="pm-employee-view-main">
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="label block-label highlight-color mb-3 clearfix">
                                        <span class="highlight-color float-left">Summary</span>
                                    </label>
                                    <div class="pm-employee-detail-box mb-3">
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Total Amount Disbursed:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ total_payment }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Bank Name:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ bank_name }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Account Title:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ account_title }}</p>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <strong class="title">Account Number:</strong>
                                            </div>
                                            <div class="col-md-8">
                                                <p>{{ wallet }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="table-holder">
                                            <table class="table" v-if="payroll_sheet && payroll_sheet.length > 0">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Amount</th>
                                                        <th>Date</th>
                                                        <th>Purpose Of Payment</th>
                                                        <th>Transaction ID</th>
                                                        <th>Payment Slip</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="ps in payroll_sheet" v-bind:value="ps.id" v-bind:key="ps.id">
                                                        <td>{{ps.name}}</td>
                                                        <td>{{ps.net_salary}}</td>
                                                        <td>{{ps.created_at | date_format}}</td>
                                                        <td>{{ps.reason}} </td>
                                                        <td>{{ps.transactionId}} </td>
                                                        <td class="text-center">
                                                            <a href="javascript:;" @click="downloadSalarySlip(ps.id)" data-toggle="tooltip" data-placement="top" title="Download" class="action"><i class="fas fa-download"></i></a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div v-else class="alert alert-warning">There is no payment slip against this vendor.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div v-show="showData === false">
                <preLoader></preLoader>
            </div>
        </template>
        <template v-else-if="crud_vendor === null && wizard_cycle === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_vendor== false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    import easyPaisaBeneficiaryComponent from '../partial/easyPaisaBeneficiaryComponent.vue';
    import meezanBeneficiaryComponent from '../partial/meezanBeneficiaryComponent.vue';
    import fincaBeneficiaryComponent from '../partial/fincaBeneficiaryComponent.vue';
    import nbpFundsBeneficiaryComponent from '../partial/nbpFundsBeneficiaryComponent.vue';
    import faysalBeneficiaryComponent from "../partial/faysalBeneficiaryComponent";
    import emoneyBeneficiaryComponent from "../partial/emoneyBeneficiaryComponent";
    export default {
        components: {
            easyPaisaBeneficiaryComponent,
            meezanBeneficiaryComponent,
            fincaBeneficiaryComponent,
            nbpFundsBeneficiaryComponent,
            faysalBeneficiaryComponent,
            emoneyBeneficiaryComponent
        },
        data() {
            return {
                editMode : 'YES',
                payroll_sheet : [],
                contract_form: new Form({
                    contract_type: "",
                    starting_date: "",
                    category_id: "",
                    report_to: null,
                    vid: this.$route.params.id
                }),
                address_form: new Form({
                    current_address: "",
                    vid: this.$route.params.id
                }),
                personal_form: new Form({
                    full_name: null,
                    mobile_no: null,
                    companyName: null,
                    dob: null,
                    cnic: null,
                    email: null,
                    vid: this.$route.params.id
                }),
                payment_form: new Form({
                    accountType : '',
                    bank : '',
                    accountNumber : '',
                    cnic : '',
                    is_default : '',
                    paymentMethod : '',
                    account_detail : false,
                    account_information : {
                        customer_name : '',
                        account_number : '',
                        bank_name : '',
                    },
                    id : this.$route.params.id
                }),
                make_default : new Form({
                    id : '',
                    vid: this.$route.params.id
                }),
                category: null,
                data: null,
                report_to_name: null,
                payment_method: null,
                wallet: null,
                account_title: null,
                bank_name: null,
                total_payment: null,
                beneficiaries: null,
                vendorCategories: null,
                bankList: null,
                banks: null,
                users: null,
                id: this.$route.params.id,
                paymentMethod: 'SIMSIM',
                showWalletDetail: false,
                showIBFTDetail: false,
                wizard_cycle: null,
                crud_vendor:null,
                vendor:null,
                showData:false,
                deleteable : null,
                vendor_id: this.$route.params.id
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_vendor|vendor').then(result => {
                this.crud_vendor = result.crud_vendor;
                this.vendor = result.vendor;
            }).then(result => {
                if(this.vendor == true){
                    if(this.$global.user_company_payment_engine == 'FINCA'){
                        this.payment_form.paymentMethod = this.payment_form.accountType = 'SIMSIM';
                    }else if(this.$global.user_company_payment_engine == 'MEEZAN'){
                        this.payment_form.paymentMethod = this.payment_form.accountType = 'EMONEY';
                    }else if(this.$global.user_company_payment_engine == 'EASY_PAISA'){
                        this.payment_form.paymentMethod = this.payment_form.accountType = 'EASY_PAISA_WALLET';
                    }else if(this.$global.user_company_payment_engine == 'NBP_FUND'){
                        this.payment_form.paymentMethod = this.payment_form.accountType = 'NBP_FUND';
                    }else if(this.$global.user_company_payment_engine == 'FAYSAL'){
                        this.payment_form.paymentMethod = this.payment_form.accountType = 'FAYSAL';
                    }
                    this.getVendor();
                    $('.selectpicker').selectpicker();
                    this.getVendorCategories();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            downloadSalarySlip(id){
                this.$Progress.start();
                axios.get('/api/downloadVendorPaymentSlip/'+id, {responseType: 'arraybuffer'})
                .then((response) => {
                    if(response.status == 200){
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'Payment Slip.pdf'
                        link.click();
                        this.showToastBox('success','File Downloaded Successfully');
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Something Went Wrong Please Try Again');
                    }

                });
            },
            hidePopup(){
                $('#editPaymentVendor').modal('hide');
            },
            isNumber(evt){
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            makeDefault(id){
                this.$Progress.start();
                this.make_default.id = id;
                this.make_default.post('/api/makeVendorDefaultBeneficiary')
                .then(res => {
                    if (res.status == 200) {
                        this.getVendor();
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Vendor account set to default successfully'
                        });

                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
            reset(){
                this.getVendor();
            },
            editVendorContractData() {
                this.$Progress.start();
                this.contract_form.post('/api/editVendorContractDetail')
                    .then(res => {
                        if (res.status == 200) {
                            this.getVendor();
                            $("#editVendor").modal("hide");
                            this.$Progress.finish();
                            toast.fire({
                                type: 'success',
                                title: 'Vendor Contact detail updated successfully'
                            });

                        } else {
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data'
                        });
                    });
            },
            editVendorAddressData() {
                this.$Progress.start();
                this.address_form.post('/api/editVendorAddressDetail')
                    .then(res => {
                        if (res.status == 200) {
                            this.getVendor();
                            $("#editAddressVendor").modal("hide");
                            this.$Progress.finish();
                            toast.fire({
                                type: 'success',
                                title: 'Vendor Address detail updated successfully'
                            });

                        } else {
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data'
                        });
                    });
            },
            editVendorPersonalData() {
                this.$Progress.start();
                this.personal_form.post('/api/editVendorPersonalDetail')
                    .then(res => {
                        if (res.data.status == 200) {
                            this.getVendor();
                            $("#editPersonalVendor").modal("hide");
                            this.$Progress.finish();
                            toast.fire({
                                type: 'success',
                                title: 'Vendor Personal detail updated successfully'
                            });

                        } else {
                            this.$Progress.fail();
                            swal.fire({
                                type: "error",
                                title: res.data.msg
                            });
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data'
                        });
                    });
            },
            getVendorCategories() {
                axios.get("/api/editVendorData")
                    .then(res => {
                        if (res.status == 200) {
                            this.vendorCategories = res.data.vendor_categories;
                            this.bankList = res.data.bankList;
                            this.users = res.data.users;
                        } else {
                            Vue.$Progress.fail();
                            swal.fire({
                                type: "error",
                                title: "Error in vendor categories"
                            });
                        }

                    }).then(res=> {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        Vue.$Progress.fail();
                        swal.fire({
                            type: "error",
                            title: "Error in vendor categories"
                        });
                    });
            },
            addVendorPaymentDetail() {
                this.$Progress.start();
                this.payment_form.post('/api/addVendorPaymentDetail')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.getVendor();
                            this.showToastBox('success','Vendor beneficiary added successfully');
                            $(".submit_form").prop('disabled',false);
                        }else if(res.data.status == 409){
                            this.$Progress.fail();
                            this.showAlertBox('error',res.data.msg);
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            changeAccountDetail(){
                this.payment_form.account_detail = false;
            },
            getVendorWalletDetail(){
                this.$Progress.start();
                if(this.payment_form.paymentMethod == 'BANK' && this.$global.user_company_payment_engine =='MEEZAN'){
                    var accNo = this.payment_form.accountNumber;
                    if(typeof accNo == 'undefined'){
                       this.showAlertBox('error','Account number field is required');
                       return false;
                    }
                    if (accNo.length < 14 || accNo.length > 24) {
                        this.$Progress.fail();
                        this.showAlertBox('error','Account number must be in between 14 to 24 digits');
                        return false;
                    }
                }
                if(this.payment_form.paymentMethod == 'IBFT' && this.$global.user_company_payment_engine =='MEEZAN'){
                    var accNo = this.payment_form.accountNumber;
                    if(typeof accNo == 'undefined'){
                       this.showAlertBox('error','Account number field is required');
                       return false;
                   }
                    if (accNo.length > 24) {
                        this.$Progress.fail();
                        this.showAlertBox('error','Account number must be 24 digits');
                        return false;
                    }
                }
                this.payment_form.post('/api/getVendorWalletDetail')
                .then(res => {
                    if(res.data.code == 200){
                        this.payment_form.account_detail = this.payment_form.accountType;
                        this.payment_form.account_detail = this.payment_form.accountType;
                        this.payment_form.account_information.customer_name = res.data.data.accountTitle;
                        this.payment_form.account_information.account_number = this.payment_form.accountNumber;
                        if(this.payment_form.accountType == 'IBFT'){
                            this.payment_form.account_information.bank_name = this.payment_form.bank.bank_name;
                            this.payment_form.account_information.bank_code = this.payment_form.bank.bank_code;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error',res.data.msg);
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getVendor() {
                axios.get("/api/editVendor/" + this.id)
                    .then(res => {
                        if (res.status == 200) {
                            if(res.data===''){
                                this.crud_vendor = false;
                                //this.showAlertBox('error','No vendor exist against this ID');
                                return false;
                            }
                            this.payroll_sheet = res.data.payrollSheet;
                            this.contract_form.contract_type = res.data.vendor_type;
                            if (res.data.category != null) {
                                this.category = res.data.category.name;
                                this.contract_form.category_id = res.data.category.id;
                            }
                            this.contract_form.starting_date = res.data.joining_date;
                            if (res.data.reported_user != null) {
                                this.contract_form.report_to = res.data.reported_user.id;
                                this.report_to_name = res.data.reported_user.name;
                            }
                            this.address_form.current_address = res.data.current_address;
                            this.personal_form.full_name = res.data.name;
                            this.personal_form.mobile_no = res.data.mobile_no;
                            this.personal_form.dob = res.data.dob;
                            this.personal_form.companyName = res.data.companyName;
                            this.personal_form.cnic = res.data.cnic;
                            this.personal_form.email = res.data.email;
                            this.personal_form.status = res.data.status;
                            if (res.data.default_beneficiary != null) {
                                this.payment_method = res.data.default_beneficiary.account_type;
                                this.wallet = res.data.default_beneficiary.account_number;
                                this.account_title = res.data.default_beneficiary.account_title;
                                this.bank_name = res.data.default_beneficiary.bank_name;
                            }
                            this.total_payment = res.data.totalpayment;
                            if (res.data.beneficiaries != null) {
                                this.beneficiaries = res.data.beneficiaries;
                            }
                            this.wizard_cycle = res.data.wizard_cycle;
                            this.deleteable = res.data.delete_able;
                        } else {
                            Vue.$Progress.fail();
                            this.showAlertBox('error','Error to load data');
                        }
                    })
                    .then(res=>{
                        if(this.crud_vendor == true){
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            this.showData = true;
                        }
                    })
                    .catch(err => {
                        Vue.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            loadBankList(){
                this.showData = false;
                axios.get('/api/ibftBankList')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.bankList != null){
                            this.banks = res.data.bankList;
                        }
                        this.showData = true;
                        $("#editPaymentVendor").modal("show");
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Error to load data');
                });
            },
            showContractModal() {
                $("#editVendor").modal("show");
            },
            showAddressModal() {
                $("#editAddressVendor").modal("show");
            },
            showPersonalModal() {
                $("#editPersonalVendor").modal("show");
            },
            showPaymentModal() {
                $("#editPaymentVendor").modal("show");
            },
            deleteVendor(id){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get('/api/deleteVendor/'+id)
                        .then(res => {
                            if(res.status == 200){
                                this.$router.push('/vendors');
                                this.showToastBox('success','Your vendor has been deleted');
                            }else{
                                this.showAlertBox('error','Error to delete vendor');
                            }
                        })
                        .catch(err => {
                            this.showAlertBox('error','Error to delete vendor');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                })
            },
        }
    }
</script>

